import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class IpLocationService {
    constructor(private http: HttpClient) {}

    async fetchIPDetails(): Promise<any | null> {
        try {
            const response = await this.http
                .get<any>('https://ipapi.co/json/')
                .toPromise();
            return {
                ip: response.ip,
                city: response.city,
                region: response.region,
                country: response.country_name,
                location: `${response.latitude}-${response.longitude}`,
                org: response.org,
                postal: response.postal,
                timezone: response.timezone,
            };
        } catch (error) {
            console.error('Error fetching IP details:', error);
            return null;
        }
    }
}
